export const SUMMARY_SENTENCE_BREAK_LIMIT = 400;
